/* SAGLOU · Artículo: progreso de lectura, apartado actual en el índice, tablas desplazables
   accesibles y compartir (con copia del enlace si el navegador no permite compartir). */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__sgj) return;
    root.__sgj = true;
    var prose = root.querySelector('[data-sgj-prose]');
    var bar = root.querySelector('[data-sgj-progress]');
    var toc = root.querySelector('[data-sgj-toc]');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-sgj-toc-link]'));
    var desk = window.matchMedia('(min-width: 990px)');

    /* En escritorio el índice siempre se abre: el resumen no es un control
       plegable allí. Reaccionar también al girar o redimensionar la pantalla. */
    if (toc) {
      function syncTocLayout() { toc.open = desk.matches; }
      syncTocLayout();
      if (desk.addEventListener) desk.addEventListener('change', syncTocLayout);
      else if (desk.addListener) desk.addListener(syncTocLayout);
    }

    /* Progreso */
    if (bar && prose) {
      var ticking = false;
      function prog() {
        ticking = false;
        var r = prose.getBoundingClientRect();
        var total = r.height - window.innerHeight * 0.6;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
        bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(prog); } }, { passive: true });
      prog();
    }

    /* Las anclas del autor se conservan. Hacer enfocable su encabezado sin
       añadir otra parada de Tab ni duplicar un tabindex ya definido. */
    var heads = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
    heads.forEach(function (h) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); });

    /* Apartado actual */
    if (links.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) {
            var on = a.getAttribute('href') === '#' + e.target.id;
            a.classList.toggle('is-current', on);
            if (on) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
      links.forEach(function (a) {
        a.addEventListener('click', function () {
          var h = document.getElementById(a.getAttribute('href').slice(1));
          if (!h) return;
          window.setTimeout(function () { h.focus({ preventScroll: true }); }, 400);
          if (toc && !desk.matches) toc.open = false;
        });
      });
    }

    /* Tablas: el acceso de teclado sigue el desbordamiento real también al
       cambiar de ancho o cargar fuentes. Conservar los atributos del autor. */
    if (prose) {
      var tableRegions = [];
      prose.querySelectorAll('table').forEach(function (t, k) {
        var p = t.parentElement;
        var scroller = p && /overflow-x\s*:\s*auto/.test(p.getAttribute('style') || '') ? p : null;
        if (!scroller) {
          scroller = document.createElement('div');
          t.parentNode.insertBefore(scroller, t);
          scroller.appendChild(t);
        }
        scroller.classList.add('sgj-scroll');
        tableRegions.push({
          scroller: scroller,
          table: t,
          attrs: [
            ['tabindex', '0'],
            ['role', 'region'],
            ['aria-label', 'Tabla ' + (k + 1) + ', desplazable']
          ].filter(function (a) { return !scroller.hasAttribute(a[0]); })
        });
      });
      if (tableRegions.length) {
        var tableTicking = false;
        function syncTables() {
          tableTicking = false;
          tableRegions.forEach(function (r) {
            var overflows = r.scroller.scrollWidth > r.scroller.clientWidth + 2;
            r.attrs.forEach(function (a) {
              if (overflows) {
                if (!r.scroller.hasAttribute(a[0])) r.scroller.setAttribute(a[0], a[1]);
              } else if (r.scroller.getAttribute(a[0]) === a[1]) {
                r.scroller.removeAttribute(a[0]);
              }
            });
          });
        }
        function queueTables() {
          if (tableTicking) return;
          tableTicking = true;
          requestAnimationFrame(syncTables);
        }
        syncTables();
        window.addEventListener('resize', queueTables, { passive: true });
        if ('ResizeObserver' in window) {
          var tableObserver = new ResizeObserver(queueTables);
          tableRegions.forEach(function (r) {
            tableObserver.observe(r.scroller);
            tableObserver.observe(r.table);
          });
        }
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueTables);
      }
    }

    /* Compartir */
    root.querySelectorAll('[data-sgj-share]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-url') || window.location.href;
        var title = b.getAttribute('data-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        if (window.SGD) window.SGD.copy(url).then(function (ok) {
          window.SGD.say(ok ? 'Enlace copiado' : 'Copia el enlace: ' + url);
        });
      });
    });
  }

  /* Mostrar el filtro activo en su carril sin desplazar la página ni el foco.
     El orden permanece estable y el ajuste es inmediato, también con movimiento reducido. */
  function revealTopic() {
    var active = document.querySelector('.sgj-topics a[aria-current="page"]');
    if (!active) return;
    var rail = active.closest('ul');
    if (!rail || rail.scrollWidth <= rail.clientWidth) return;
    var a = active.getBoundingClientRect();
    var r = rail.getBoundingClientRect();
    if (a.left < r.left + 16) rail.scrollLeft += a.left - r.left - 16;
    else if (a.right > r.right - 16) rail.scrollLeft += a.right - r.right + 16;
  }

  function boot() {
    document.querySelectorAll('[data-sgj-article]').forEach(init);
    revealTopic();
  }
  window.addEventListener('resize', revealTopic, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(revealTopic);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
